import { useEffect } from 'react'

import useOpenExternalLink from 'app/hooks/useOpenExternalLink'
import { downloadAppUrls } from 'app/utils/constants/options.constants'

export const useCheckUserRedirect = () => {
  const { openLink } = useOpenExternalLink()

  const getRedirectLink = () => {
    const userAgent = navigator.userAgent
    const isAndroid = /android/i.test(userAgent)
    const isIOS = /iphone|ipad|ipod/i.test(userAgent)

    if (isAndroid) return downloadAppUrls.google

    if (isIOS) return downloadAppUrls.apple

    return
  }

  const checkUserRedirect = () => {
    try {
      const link = getRedirectLink()

      if (!link) return

      openLink({ link, target: '_self' })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    checkUserRedirect()
  }, [])
}
